import REORGANIZE_DASHBOARD_ROUTES from './reorganize-dahsboard';

export default [
  {
    path: 'operations',
    name: 'operations-menu',
    component: () => import('@/views/Operations.vue'),
    children: [
      {
        path: '/operations',
        name: 'operations',
        component: () => import('@/views/operations/Menu'),
        meta: { IsParent: true },
      },
      {
        path: '/operations/maintenance/dashboard',
        name: 'dashboardMaintenance',
        component: () => import('@/views/operations/maintenance/Main'),
      },
      {
        path: '/operations/maintenance/dashboard/management/:id?',
        name: 'dashboardMaintenanceManagement',
        component: () => import('@/views/operations/maintenance/Management'),
      },
      {
        path: '/operations/maintenance/dashboard/management/:id/participants',
        name: 'DashboardMaintenanceManagementParticipants',
        component: () =>
          import('@/views/operations/maintenance/components/Participants'),
      },
      {
        path:
          '/operations/maintenance/dashboard/management/:postId/workshop/:workshopId/configure-tests/:id?/:readOnly?',
        name: 'dashboardMaintenanceConfigureTestForm',
        component: () =>
          import('@/views/operations/maintenance/ConfigureTestForm'),
      },
      {
        path: '/operations/message',
        name: 'message',
        component: () => import('@/views/operations/message/Main'),
      },
      {
        path: '/operations/message/management',
        name: 'message-management',
        component: () => import('@/views/operations/message/MessageManagement'),
      },
      {
        path: '/operations/calendar',
        name: 'calendarMain',
        component: () => import('@/views/operations/calendar/Main'),
      },
      {
        path: '/operations/calendar/event-management/:id?',
        name: 'calendarEventManagement',
        component: () => import('@/views/operations/calendar/EventManagement'),
      },
      {
        path: '/operations/schoolManagement',
        name: 'schooltManagement',
        component: () => import('@/views/operations/schoolManagement/Main'),
      },
      {
        path: '/operations/metapr',
        name: 'MetaPR',
        component: () => import('@/views/operations/metaPR/Main'),
      },
      {
        path: '/operations/schoolManagement/addEdit/:id?',
        name: 'AddEditSchool',
        component: () =>
          import(
            '@/views/operations/schoolManagement/components/newSchool/AddEditSchool'
          ),
      },
      {
        path: '/operations/formManagement',
        name: 'formManagement',
        component: () => import('@/views/operations/formManagement/Main'),
      },
      {
        path: '/operations/formManagement/createEditForm',
        name: 'CreateEditForm',
        component: () =>
          import(
            '@/views/operations/formManagement/components/newForm/CreateEditForm'
          ),
      },
      {
        path: '/operations/systemParams',
        name: 'systemParameter',
        component: () =>
          import('@/views/operations/systemParameterManagment/Wrapper'),
        children: [
          {
            path: '',
            name: 'systemParameter',
            component: () =>
              import('@/views/operations/systemParameterManagment/Main'),
          },
          {
            path: 'createEdit/:id',
            name: 'createEditSystemParameter',
            component: () =>
              import(
                '@/views/operations/systemParameterManagment/CreateEditSystemParameter'
              ),
          },
        ],
      },
      {
        path: 'guidesAndVideos',
        name: 'guidesAndVideos',
        component: () => import('@/views/operations/guidesAndVideos/Wrapper'),
        children: [
          {
            path: '',
            name: 'guidesAndVideos',
            component: () => import('@/views/operations/guidesAndVideos/Main'),
          },
          {
            path: 'manage/:id?',
            name: 'manageGuidesAndVideos',
            component: () =>
              import('@/views/operations/guidesAndVideos/Manage'),
          },
        ],
      },
      {
        path: '/operations/public-portal',
        name: 'operationPublicPortal',
        component: () => import('@/views/operations/publicPortal/Wrapper'),
        children: [
          {
            path: 'applications',
            name: 'operationPublicPortalApplications',
            component: () =>
              import('@/views/operations/publicPortal/applications/Main'),
          },
          {
            path: 'applications/edit/:id',
            name: 'operationPublicPortalEditApplication',
            component: () =>
              import('@/views/operations/publicPortal/applications/Edit'),
          },
          {
            path: 'maintenance',
            name: 'operationPublicPortalMaintenance',
            component: () =>
              import('@/views/operations/publicPortal/schedule-items/Main'),
          },
          {
            path: 'maintenance/new-item',
            name: 'operationPublicPortalNewItem',
            component: () =>
              import('@/views/operations/publicPortal/schedule-items/New'),
          },
          {
            path: 'maintenance/edit-item/:id',
            name: 'operationPublicPortalEditItem',
            component: () =>
              import('@/views/operations/publicPortal/schedule-items/New'),
          },
        ],
      },
      {
        path: '/operations/sr-weeks-configuration',
        name: 'srTeachingWeeksConfiguration',
        component: () =>
          import('@/views/operations/srTeachingWeeksConfiguration/Main'),
      },
      {
        path: '/operations/strengthsneedsmanagement',
        name: 'strengthsNeedsManagement',
        component: () =>
          import('@/views/operations/strengthsNeedsManagement/Main'),
      },
      {
        path: '/operations/strengthsneedsmanagement/add',
        name: 'addStrengthsNeedsManagement',
        component: () =>
          import('@/views/operations/strengthsNeedsManagement/AddSkill'),
      },
      {
        path: '/operations/form-recognizer',
        component: () =>
          import(
            '@/views/operations/processCertificationMonthlyServices/Wrapper.vue'
          ),
        children: [
          {
            path: '/',
            name: 'Main',
            component: () =>
              import(
                '@/views/operations/processCertificationMonthlyServices/Main.vue'
              ),
          },
        ],
      },
      {
        path: '/operations/workshop',
        name: 'workshop',
        component: () => import('@/views/operations/workshop/Wrapper'),
        children: [
          {
            path: '',
            name: 'workshop',
            component: () => import('@/views/operations/workshop/Main'),
          },
        ],
      },
      {
        path: '/operations/ai-prompt-config',
        name: 'aiPromptConfig',
        component: () => import('@/views/operations/aiPromptConfig/Wrapper'),
        children: [
          {
            path: '',
            name: 'aiPromptConfig',
            component: () => import('@/views/operations/aiPromptConfig/Main'),
          },
          {
            path: 'create',
            name: 'aiPromptConfigCreateEdit',
            component: () =>
              import('@/views/operations/aiPromptConfig/CreateEdit'),
          },
          {
            path: 'usage',
            name: 'aiPromptConfigUsage',
            component: () =>
              import('@/views/operations/aiPromptConfig/UsageDashboard'),
          },
        ],
      },
      ...REORGANIZE_DASHBOARD_ROUTES,
    ],
  },
];
